import { getPage } from './getPage';
import type { PageGroupItemViewModel } from '@trinnvis/dabih-api-client';

export function isPageId(pageId: number, pages: PageGroupItemViewModel[]): boolean {
  const page = getPage(pageId, pages);
  return !!page;
}
